import React from 'react'
import * as Icon from 'react-feather';
export default function Cont(Props) {
  return (
   
   <>
   
   <div class="page-title-area">
               <div class="d-table">
                   <div class="d-table-cell">
                       <div class="container">
                           <h2>Contact Us</h2>
                       </div>
                   </div>
               </div>
           </div>
          
           <section class="contact-info-area ptb-80">
               <div class="container">
                   <div class="row">
                       <div class="col-lg-4 col-md-6">
                           <div class="contact-info-box">
                               <div class="icon">
                                   <Icon.Mail/>
                               </div>
                               <h3>Mail</h3>
                               <p>Kasthuri Venkatesh </p>
                               <p><a href="/">{Props.Mail}</a></p>
                           </div>
                       </div>
   
                       <div class="col-lg-4 col-md-6">
                           <div class="contact-info-box">
                               <div class="icon">
                                  <Icon.MapPin/>
                               </div>
                               <h3>Visit</h3>
                               <p>{Props.Address}</p>
                           </div>
                       </div>
   
                       <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                           <div class="contact-info-box">
                               <div class="icon">
                                   <Icon.Phone/>
                               </div>
                               <h3>Call</h3>
                               <p><a href="/">+91 9941620909</a></p>
                           </div>
                       </div>
                   </div>
               </div>
           </section>
          
           <iframe src={Props.MapIn} width="100%" height="450" className='b-0' allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="myMap"/>
           
           </> 
           
  )
}
